module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\">\n  <i class=\"fa fa-line-chart\"></i> Historial\n  </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <section>\n    <page-timeline ng-model=\"$ctrl.Tiempos\" representante=\"$ctrl.representante\" ></page-timeline>\n  </section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/probolivia/ddjj/historial.modal.html
// module id = 93
// module chunks = 0